import React, { useState,useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";

import Select from "react-select";
import logo from "../../assets/img/logo.png";
import noperson from "../../assets/img/noperson.svg";
import LoadingScreen from "react-loading-screen";
import "react-responsive-pagination/themes/classic.css";
import { useHistory } from "react-router-dom";
import apiService from "../../variables/apiService"
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Label,
  Row,
  Col,
  CustomInput,
} from "reactstrap";
import axios from "axios";
import {
  ROLE_LIST,
  EDIT_USER,
  INSERT_USER,
  UPDATE_USER,
  BASE_URL_CHAT_WHATSAPP,
  ALL_CLIENT_LIST,
  CLIENT_API,
  ROLE_SUPER_ADMIN_NAME,
  USER_NAMES_LIST,
  USER_RELOAD
} from "../../constants";

import NotificationAlert from "react-notification-alert";

let clientsList = [];
const initialState = {
  username: "",
  password: "",
  mobile: "",
  email: "",
  client: 0,
  firstName: "",
  lastName: "",
  profile: noperson,
  status:0,
  systemid:"",
  senderid:""
};
let drpdwn = [];
const CreateUser = (props) => {
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const notificationAlertRef = React.useRef(null);
  const profileRef = React.useRef(null);
  const [users, setUsers] = React.useState(initialState);
  const [error,setError]= useState();
  const [usersList,setUsersList]= useState([]);

 
  useEffect(() => {
    roleDrpdwn(user?.client);
    usernames();
    user?.role!==ROLE_SUPER_ADMIN_NAME?fetchClientbyid(user?.client):getClients();
  
  }, []);

  const usernames=()=>{

    // axios.get(USER_NAMES_LIST).then(res=>{
    //   setUsersList(res?.data?.message)
    // }).catch(err=>console.log("Fetching Users => ",err))
    apiService.getData(USER_NAMES_LIST).then(res=>{
        setUsersList(res?.data?.message)
      }).catch((error) => {
        console.log("--err-", error)
        let options={}
          options = {
          place: "tr",
          message: "Unable to Fetch user Names",
          type: "warning",
  
          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
  
  }

  const uploadProfile = (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    apiService
      .postData(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        setUsers({ ...users, profile: response?.data?.Response });
      })
      .catch((err) => console.log("err==>", err));
  };
  const fetchUserDtls = async() => {
   
    if (props?.location?.state?.id) {
      let id = props?.location?.state?.id;
    
     await apiService.postData(EDIT_USER, { userid: id.toString() })
        .then((response) => {
          const res = response?.data?.message[0];
         
          drpdwn.push({ value: res.client, label: res.client})
          const clientObj = clientsList.filter(item=>item.value===res.client)
          console.log(clientsList,"==users");
          console.log(res,"==res");

          setUsers({
            username: res?.username,
            password: res?.password,
            mobile: res?.mobile,
            email: res?.email,
            senderid: res?.senderid,
            systemid: res?.systemid,

            firstName: res?.first_name,
            lastName: res?.last_name,
            profile: res?.image_url,
            client: clientObj[0],
            role:{ value: res.role, label: res.role },
            status:Number(res.status)
          });
         

          
         
        })
        .catch((error) => {
          console.log("????", error);
        });
    }
  };

  
  const onchangeHandler = (e) => {
    const { name, value } = e.target;
    if(name==="username"){
      const isExist = usersList?.filter(item=>item?.username?.toLowerCase()==value.toLowerCase());
  
      if(isExist.length!=0){
      setError({username:"username already exist !"})

      }else{
        setError()

      }
  
    }
    setUsers({ ...users, [name]: value });
  };

  const submitInsertUser = () => {
   
    const isvalid = validate()
    setError(isvalid)
    if(Object?.keys(isvalid)?.length===0){
    let resultuser = {
      username: users.username,
      password: users.password,
      mobile: users.mobile,
      email: users.email,
      role: users?.role?.value,
      client: users?.client?.value,
      status:users.status,
      first_name: users.firstName,
      last_name: users.lastName,
      image_url: users.profile,
      senderid:users?.senderid,
      systemid:users?.systemid
    };

    if (props?.location?.state?.id) {
      let payload = {...resultuser,id:props?.location?.state?.id.toString(),};
  

      apiService
        .postData(UPDATE_USER, payload)
        .then((response) => {
          let options = {};
          options = {
            place: "tr",
            message: "Updated Successfully",
            type: "success",

            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
          setUsers(initialState);
          reloadusers()
          navigate.push("/admin/user/userlist");
        })
        .catch((error) => {
          console.log("catch--", error);
        });
    } else {
        apiService
          .postData(INSERT_USER, resultuser)
          .then((response) => {
            let options = {};
            options = {
              place: "tr",
              message: "Saved Successfully",
              type: "success",

              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);
            setUsers(initialState);
            reloadusers()
            navigate.push("/admin/user/userlist");
          })
          .catch((error) => {
            console.log("catch--", error);
          });
      
    }
  }
  };

  const reloadusers=async()=>{
   // await axios.get(USER_RELOAD).then(res=>console.log("Reloaded")).catch(err=>console.log("Reloaded Failed"))
   await apiService.getData(USER_RELOAD).then(res=>console.log("Reloaded")).catch(err=>console.log("Reloaded Failed"))
  }
  const validate=()=>{
    
    let errors={}
    const onlylettersRegex =/^([^0-9]*)$/;
   // const onlylettersRegex =/^[a-zA-Z]+$/;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]/i;
    if(!users.firstName){
      errors.firstName="First Name Required"
    }else if(users.firstName<3){
      errors.firstName="First Name Too Short"
    }else if(!(users.firstName.match(onlylettersRegex))){
      errors.firstName="Please Enter Valid Name"
    }
    if(!users.lastName){
      errors.lastName="Last Name Required"
    }else if(users.lastName<3){
      errors.lastName="Last Name Too Short"
    }else if(!(users.lastName.match(onlylettersRegex))){
      errors.lastName="Please Enter Valid Name"
    }
    if(!users.username){
      errors.username="User name Required"
    }else if(users.username<3){
      errors.username="Name Too Short"
    }else if(error?.username){
      errors.username=error?.username
    }
    if(users.mobile.length!=10){
      errors.mobile="Number should be 10 digits"
    }
    if(!users.email.match(emailRegex)){
      errors.email="Please provide valid email"
    }
    if(!users.password){
      errors.password="Password Required"
    }
    if(users.password.length<3){
      errors.password="Password Too Short"
    }
    if(!users?.client?.value){
      errors.client="Please select Client"
    }
    if(!users?.role?.value){
      errors.role="Please select role"
    }
    return errors;
  }


  const roleDrpdwn = (client) => {
    drpdwn=[]
    apiService
      .getData(ROLE_LIST+'?client_id='+client)
      .then((response) => {
        response?.data?.message?.map((item, index) => {
         
          drpdwn.push({value: item.role, label: item.role });
        });
      })
      .catch((error) => {
        console.log("????", error);
      });
  };
 
  const fetchClientbyid = async (id) => {
    
    setIsLoading(true)
    clientsList = [];
   
    if (id) {
      axios
        .post(CLIENT_API, { id: id })
        .then((res) => {
          setIsLoading(false)
          let clientObj = res?.data[0];
          res?.data?.map((item)=>{
            clientsList.push({ value: item.id, label: item.company_name})
          })
        
         
          setUsers(prev=>({...prev,client:{ value: clientObj.id, label: clientObj.company_name}}));
         
        })
        .catch((e) => {console.log(e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        });
        props?.location?.state?.id&&fetchUserDtls();
    }
    
  };
  const getClients=async()=>{
   
    setIsLoading(true)
    clientsList = [];
    await apiService.getData(`${ALL_CLIENT_LIST}?client_id=${user?.client}`).then(res=>{
      setIsLoading(false)
     
      res?.data?.data?.map(item=> clientsList.push({ value: item.id, label: item.company_name}))
     
    }).catch(err=>{
      let options = {};
      options = {
        place: "tr",
        message: "Unable fetch records111",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
    })
    props?.location?.state?.id&&fetchUserDtls();
    console.log("client",clientsList);
}
 const changeClient=(value)=>{
  setUsers(prev=>({...prev,client:value}));
  roleDrpdwn(value?.value)
 }

  return (
    <>
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Row>
                <Row>
                  <Col sm="10">
                    <h4 className="mt-4 add-content" style={{width:"200px"}} onClick={() => navigate.push("/admin/user/userlist")}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"
                        
                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </Button>
                     {props?.location?.state?.id?"Update User":"Create User"} 
                    </h4>
                  </Col>
                </Row>
               
                <Col md="10" sm="8">
                 
                  <Row>
                
                     <Col sm="4" className="mb-4">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="client"
                        value={users.client}
                        onChange={(value) => {
                          changeClient(value)
                          
                        }}
                        options={clientsList}
                      />
                      <span style={{color:"red"}}>{error?.client}</span>
                    </Col>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="First Name"
                        type="text"
                        name="firstName"
                        value={users.firstName}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.firstName}</span>
                    </Col>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Last Name"
                        type="text"
                        name="lastName"
                        value={users.lastName}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.lastName}</span>
                    </Col>

                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="User Name"
                        type="text"
                        name="username"
                        value={users.username}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.username}</span>
                    </Col>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Password"
                        type="text"
                        name="password"
                        value={users.password}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.password}</span>
                    </Col>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Mobile Number"
                        type="number"
                        maxLength={10}
                        name="mobile"
                        value={users.mobile}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.mobile}</span>
                    </Col>
                  
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Email Id"
                        type="text"
                        name="email"
                        value={users.email}
                        onChange={onchangeHandler}
                      />
                      <span style={{color:"red"}}>{error?.email}</span>
                    </Col>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Sender Id"
                        type="text"
                        maxLength={20}
                        name="senderid"
                        value={users.senderid}
                        onChange={onchangeHandler}
                      />
                     
                    </Col>  <Col sm="4" className="mb-4">
                      <MDBInput
                        label="System Id"
                        type="text"
                        maxLength={20}
                        name="systemid"
                        value={users.systemid}
                        onChange={onchangeHandler}
                      />
                     
                    </Col>
                    <Col sm="4" className="mb-4">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="Select Role"
                        value={users?.role}
                        onChange={(value) => setUsers({...users,role:value})}
                        options={drpdwn}
                        placeholder="Select Role"
                      />
                      <span style={{color:"red"}}>{error?.role}</span>
                    </Col>
               
                    
                    <Col sm="4" className="mb-2 mt-2">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">In-active</span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={users?.status===0?true:false}
                          //checked={isActive.current}
                          onChange={(e) =>{
                          
                             setUsers({...users,status:e.target.checked==true?0:1})}
                            }
                        />
                        <span className="ml-n2">Active</span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md="2" sm="4">
                  <Row style={{ backgroundColor: "#f3f3f3", height: "70%" }}>
                    <input
                      ref={profileRef}
                      type="file"
                      id="file"
                      accept="image/png,image/jpeg"
                      onChange={(e) => {
                        uploadProfile(e);
                      }}
                      style={{ display: "none" }}
                    />
                    <img
                      src={users.profile}
                      alt="no image"
                      onClick={() => profileRef.current.click()}
                      style={{
                        margin: "5px",
                        height: "200px",
                        width: "200px",
                        objectFit: "fill",
                      }}
                    />
                  </Row>
                  <Row>
                    <h4
                      style={{
                        backgroundColor: "#f3f3f3",
                        padding: "2px",
                        textAlign: "center",
                      }}
                    >
                      Upload here
                    </h4>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={() => submitInsertUser()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateUser;
